import React from 'react';
import { DEFAULT_LOGO_SIZE } from '@eventbrite/legacy-eds.global-header/constants';
import { Icon } from '@eventbrite/legacy-eds.icon';
import { LogoEBrand } from '@eventbrite/legacy-eds.iconography';
import { COLORS_MAP } from '@eventbrite/legacy-eds.styles/color';
import { useIntl } from 'react-intl';
import styles from './GlobalHeaderLogo.module.scss';
import {
    DEFAULT_LOGO_TYPE,
    DEFAULT_LOGO_COLOR,
    DEFAULT_LOGO_TITLE,
} from '@eventbrite/legacy-eds.global-header/constants/Logo';

export const GlobalHeaderLogo = ({
    info,
}: {
    info: {
        url?: string;
        iconType?: string | JSX.Element;
        iconColor?: string;
        iconTitle?: string;
        iconWidth?: string | number;
        iconHeight?: string | number;
        backgroundColor?: string;
        linkprops?: any;
    };
}) => {
    const {
        url,
        iconType = DEFAULT_LOGO_TYPE,
        iconColor = DEFAULT_LOGO_COLOR,
        iconTitle = DEFAULT_LOGO_TITLE,
        iconWidth = DEFAULT_LOGO_SIZE.width,
        iconHeight = DEFAULT_LOGO_SIZE.height,
        backgroundColor,
        ...linkprops
    } = info;
    const { formatMessage } = useIntl();

    // workaround to apply the eds-bg-color--${color} class
    let style = {};
    if (backgroundColor && COLORS_MAP[backgroundColor]) {
        style = {
            backgroundColor: COLORS_MAP[backgroundColor],
        };
    }

    return (
        <a
            href={url}
            className={styles.root}
            aria-label={formatMessage({ id: 'Home', defaultMessage: 'Home' })}
            data-testid="consumer-header-logo-link"
            style={style}
            {...linkprops}
        >
            <div className={styles.desktopLogo}>
                <Icon
                    type={iconType}
                    color={iconColor}
                    title={iconTitle}
                    isBlockLevel={true}
                    height={iconHeight}
                    width={iconWidth}
                />
            </div>

            <div className={styles.mobileLogo}>
                <Icon
                    type={<LogoEBrand />}
                    color={iconColor}
                    title={iconTitle}
                    isBlockLevel={true}
                    height={iconHeight}
                />
            </div>
        </a>
    );
};
